import { useRecoilValue } from 'recoil'

import { $businessUnitList } from './selector'

export function useBusinessUnitList() {
  const buList = useRecoilValue($businessUnitList)
  return buList
}
